export enum OrganizationType {
    Girls,
    Boys
}

export enum GenderType {
    Women = 'Women',
    Men = 'Men',
}